<template>
    <div style="background: linear-gradient(199deg, #FCF5FF -2.92%, #F2F9FE 76.01%);">
        <PageHeader>
            <template #navbar>
                <Navbar />
            </template>
            <template #pagetitle>
                <PageTitle :pageTitle="$t('pages.titles.contact')" />
            </template>
        </PageHeader>
        <ContactInfo />
        <ContactForm />
        <FreeTrial variant="light"/>
        <Footer />
    </div>
</template>

<script>
import PageHeader from '../Layout/PageHeader'
import Navbar from '../Layout/Navbar'
import PageTitle from '../Common/PageTitle'
import ContactInfo from '../Contact/ContactInfo'
import ContactForm from '../Contact/ContactForm'
import FreeTrial from '../Common/FreeTrial'
import Footer from '../Layout/Footer'

export default {
    name: 'ContactPage',
    components: {
        PageHeader,
        Navbar,
        PageTitle,
        ContactInfo,
        ContactForm,
        FreeTrial,
        Footer,
    }
}
</script>
